/** @format */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { Grid, Typography } from "@mui/material"

import CustomButtonRounded from "../Buttons/CustomButtonRounded"
import OptimizedImage from "../OptimizedImage"

const ErrorMessage = () => {
    return (
        <>
            <Grid item>
                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        mt: "1.5rem",
                        p: 2,
                        color: "textPrimary",
                    }}
                >
                    UH-OH! Looks like something went wrong sending your coupon.
                </Typography>
            </Grid>
            <Grid item sx={{ width: "100%" }}>
                <OptimizedImage
                    src={"/images/uh-oh-dents.jpg"}
                    alt=""
                    layout="fill"
                    objectFit="cover"
                    containerCss={css`
                        div {
                            padding-top: 50% !important;
                        }
                    `}
                />
            </Grid>
            <Grid item>
                <Typography
                    component="p"
                    align="center"
                    sx={{
                        fontSize: "1.25rem",
                        p: 2,
                        color: "textPrimary",
                    }}
                >
                    Check your inbox for your exclusive Maaco coupon. Ready to
                    save big on your next refresh?
                </Typography>
            </Grid>
            <Grid
                container
                item
                rowSpacing={0}
                columnSpacing={0}
                sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    bgcolor: "#ebebeb",
                    borderRadius: 2,
                }}
            >
                <Grid item xs={10} md={5}>
                    <CustomButtonRounded
                        fullWidth
                        variant="contained"
                        color="secondary"
                        handleOnClick={() => setOpenAppointments(true)}
                        sxProps={{
                            fontWeight: "700",
                            "&:hover": {
                                borderColor: "white",
                                borderWidth: 2,
                            },
                        }}
                    >
                        Book An Appointment
                    </CustomButtonRounded>
                </Grid>
                <Grid item xs={10} md={5}>
                    <CustomButtonRounded
                        fullWidth
                        path="/services"
                        variant="contained"
                        color="primary"
                        sxProps={{
                            mb: "1.5rem",
                            fontWeight: "700",
                            "&:hover": {
                                borderColor: "white",
                                borderWidth: 2,
                            },
                        }}
                    >
                        Learn More
                    </CustomButtonRounded>
                </Grid>
            </Grid>
        </>
    )
}

export default ErrorMessage
